var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandsEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M19.58 33.814l18.213-18.093a4 4 0 0 1 5.638 0l18.213 18.093a4 4 0 0 1 1.18 2.838v63.94a4 4 0 0 1-4 4H22.4a4 4 0 0 1-4-4v-63.94a4 4 0 0 1 1.18-2.838z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "d",
    width: 44.425,
    height: 90.033,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M16.882 28.503l18.213-18.094a4 4 0 0 1 5.638 0l18.212 18.094a4 4 0 0 1 1.181 2.837v63.94a4 4 0 0 1-4 4H19.701a4 4 0 0 1-4-4V31.34a4 4 0 0 1 1.181-2.837z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "e",
    width: 44.425,
    height: 90.033,
    x: 0,
    y: 0,
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("ellipse", {
    id: "f",
    cx: 32.799,
    cy: 88.533,
    rx: 6.064,
    ry: 6.171
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "g",
    cx: 76.645,
    cy: 46.82,
    rx: 6.402,
    ry: 6.446
  }), /*#__PURE__*/React.createElement("path", {
    id: "h",
    d: "M13.902 29.398l23.36-22.45a4 4 0 0 1 5.544 0l23.36 22.45a4 4 0 0 1 1.229 2.884v77.237a4 4 0 0 1-4 4H16.674a4 4 0 0 1-4-4V32.282a4 4 0 0 1 1.228-2.884z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "i",
    cx: 32.268,
    cy: 90.888,
    rx: 6.567,
    ry: 6.635
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M264.255 111.742C263.59 172.197 214.41 221 153.842 221 92.86 221 43.423 171.527 43.423 110.5c0-5.053.34-10.026.995-14.899H9.933C4.447 95.601 0 91.154 0 85.67c0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H42.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H71.17C91.401 14.401 120.941 0 153.842 0 201.3 0 241.763 29.96 257.38 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M161.094 101C169.561 99.522 176 92.085 176 83.133 176 73.12 167.941 65 158 65s-18 8.119-18 18.133c0 8.171 5.364 15.08 12.738 17.347"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1 -1) rotate(-28 -293.03 -237.039)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    d: "M9.805 81.086l15.655 25.119a4 4 0 0 0 5.4 1.346l25.615-14.829a4 4 0 0 0 1.877-2.494l17.284-69.323a4 4 0 0 0-2.913-4.849L31.45 5.766a4 4 0 0 0-4.849 2.913L9.318 78.002a4 4 0 0 0 .487 3.084z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#64808C",
    strokeDasharray: "2,2,2,2",
    strokeWidth: 2,
    mask: "url(#d)",
    transform: "scale(1 -1) rotate(-14 -444.586 0)",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(11 8.347 109.554)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M6.895 76.539l15.656 25.119a4 4 0 0 0 5.398 1.346l25.616-14.829a4 4 0 0 0 1.878-2.494l17.284-69.323a4 4 0 0 0-2.914-4.85L28.541 1.219a4 4 0 0 0-4.848 2.914L6.408 73.455a4 4 0 0 0 .487 3.084z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    stroke: "#64808C",
    strokeDasharray: "2,2,2,2",
    strokeWidth: 2,
    mask: "url(#e)",
    transform: "scale(1 -1) rotate(-14 -404.027 0)",
    xlinkHref: "#b"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "scale(1 -1) rotate(-14 -688.241 0)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#f"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.799,
    cy: 88.533,
    stroke: "#64808C",
    rx: 5.564,
    ry: 5.671
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-31 215.61 -62.204)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#g"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 76.645,
    cy: 46.82,
    stroke: "#64808C",
    rx: 5.902,
    ry: 5.946
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-14 402.95 -416.594)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#h"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M14.249 29.759a3.5 3.5 0 0 0-1.075 2.523v77.237a3.5 3.5 0 0 0 3.5 3.5h46.72a3.5 3.5 0 0 0 3.5-3.5V32.282a3.5 3.5 0 0 0-1.074-2.523L42.46 7.308a3.5 3.5 0 0 0-4.85 0l-23.361 22.45z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-14 140.974 -416.594)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#i"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 32.268,
    cy: 90.888,
    stroke: "#64808C",
    rx: 6.067,
    ry: 6.135
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M153 100.692c1.954 1.153 4.37 1.543 7.246 1.173C168.825 100.438 174.943 93.75 176 85"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    strokeLinecap: "square",
    d: "M147.425 119.412l16.15 60.176M161.425 117.412l16.15 60.176M174.425 113.412l16.15 60.176"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandsEmpty);
export default __webpack_public_path__ + "static/media/brands-empty.c0e29cdaf887fc0dba79fff79bb6ea58.svg";
export { ForwardRef as ReactComponent };